import React from 'react';
import CardsContent from "./cards-content.jsx";
import AbsenceDaysReasonContent from "./absence-days-reason-content.jsx";
import AbsenceDetailsContent from "./absence-details-content.jsx";

const ReportContent = ({ data, collapsed }) => {
    return (
        <>
            <CardsContent key={`absence-cards-${collapsed}`} data={data}/>
            <AbsenceDaysReasonContent key={`absence-days-${collapsed}`} data={data}/>
            <AbsenceDetailsContent key={`absence-details-${collapsed}`} data={data}/>

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;